import { Button, Dropdown, Flex, Icons } from "@components/index";
import {
  useFilterContext,
  ViewsEnum,
} from "@pages/Dashboard/contexts/Filter.context";
import { useCallback } from "react";

const VIEW_OPTIONS = [
  { label: "Status", icon: "anotacoes", value: ViewsEnum.grid },
  { label: "Gerencial", icon: "business", value: ViewsEnum.gantt },
  { label: "Detalhada", icon: "search", value: ViewsEnum.detalhada },
] as const;

const TRIGGER = (
  <Flex.Row alignItems="center" gap="6px" className="hand">
    <Icons icon="eye-1" size="sm" />
    <span>Visão</span>
    <Icons icon="chevron-down" size="sm" />
  </Flex.Row>
);

const ViewDropDown: React.FC = () => {
  const { setView } = useFilterContext();

  const handleViewChange = useCallback(
    (view: ViewsEnum, close: () => void) => {
      close();
      setView?.(view);
    },
    [setView]
  );

  return (
    <Dropdown position="bottomRight" trigger={TRIGGER}>
      {(close) => (
        <>
          {VIEW_OPTIONS.map(({ label, icon, value }) => (
            <Button
              key={value}
              blockedWidth
              size="lg"
              buttonStyle="tertiary"
              content="start"
              label={label}
              icon={icon}
              onClick={() => handleViewChange(value, close)}
            />
          ))}
        </>
      )}
    </Dropdown>
  );
};

export default ViewDropDown;
